export type InputProps = {
  type: string;
  id?: string;
  placeholder?: string;
  pattern?: string;
  required?: boolean;
  className?: string;
  value?: string | number;
  min?: number;
  error?: string;
  disabled?: boolean;
  name?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
};

export const Input = ({
  type,
  id,
  placeholder,
  pattern,
  required,
  className,
  value,
  min,
  error,
  disabled,
  name,
  onChange,
}: InputProps) => {
  return (
    <>
      <input
        type={type}
        id={id}
        name={name}
        className={
          className
            ? `${className} ${error ? "!border-red-500" : ""}`
            : `bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary focus:border-primary block w-full px-2 py-[10px] dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary dark:focus:border-primary ${
                error ? "!border-red-500" : ""
              } disabled:opacity-50 disabled:cursor-not-allowed`
        }
        placeholder={placeholder}
        pattern={pattern}
        required={required}
        value={value}
        onChange={onChange}
        disabled={disabled}
        min={min}
      />
      {error && <p className="text-red-500 text-sm">{error}</p>}
    </>
  );
};
